import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { TRADE_REPORTING_BLUE_SHEET_BASE_PATH } from '../../../../../../../../../features/trade-reporting/blue-sheet/trade-reporting-blue-sheet-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/blue-sheet/_blue-sheet')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'blue-sheet-list',
        label: 'Reports',
        to: TRADE_REPORTING_BLUE_SHEET_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
